<!-- components/GlobalLoader.vue -->
<template>

    <div class="loading-state" v-if="loaderStore.isLoading">
        <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';
import { useLoaderStore } from '@/stores/loader'; // Adjust path as needed

const loaderStore = useLoaderStore();
</script>

<style scoped>
.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 999999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>